import { render, staticRenderFns } from "./modal-forget-pass.vue?vue&type=template&id=01064371"
import script from "./modal-forget-pass.vue?vue&type=script&lang=js"
export * from "./modal-forget-pass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports